/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type GetAssignmentDataSourcesPathParams = NonNullable<
  operations['getAssignmentDataSources']['parameters']['path']
>;

export type GetAssignmentDataSourcesQueryParams = NonNullable<
  operations['getAssignmentDataSources']['parameters']['query']
>;

export interface Input extends GetAssignmentDataSourcesPathParams {
  apiVersion?: string;
  query?: GetAssignmentDataSourcesQueryParams;
}

export async function getAssignmentDataSources(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/internal/projects/{projKey}/assignment-data-sources', {
    params: { path, query },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
